import React from 'react';
import clsx from 'clsx';

const SkeletonListItemMobile = ({ items, cells, loading }) => {
  return (
    <>
      {loading &&
        [...Array(items)].map((e, index) => (
          <li
            className={clsx(
              'flex',
              'flex-col',
              'gap-2',
              'p-4',
              'border',
              'border-solid',
              'border-gray-300',
              'rounded',
              'mb-4',
              'bg-white',
              'skeleton'
            )}
            key={index}
          >
            <span
              className="skeleton max-w-[40%] rounded-sm bg-gray-200"
              key={index}
            >
              &nbsp;
            </span>
            <div
              className={clsx(
                'grid',
                `grid-cols-${cells - 3}`,
                `md:grid-cols-${cells}`
              )}
            >
              {[...Array(cells - 1)].map((e, index) => (
                <div
                  className="flex max-w-[40%] flex-col gap-[2px]"
                  key={index}
                >
                  <span className="skeleton rounded-sm bg-gray-200">
                    &nbsp;
                  </span>
                  <span className="skeleton rounded-sm bg-gray-200">
                    &nbsp;
                  </span>
                </div>
              ))}
            </div>
          </li>
        ))}
    </>
  );
};

export default SkeletonListItemMobile;
